import { Component, inject, EventEmitter, Output } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import {
  Collaborator,
  CollaboratorInvitation,
  PdvAccessSettings,
} from "@models/collaborator";
import {
  PdvAccessFieldsComponent,
  pdvAccessControls,
  pdvAccessPayload,
} from "./pdv-access-fields.component";

@Component({
  selector: "app-pdv-permission-dialog",
  imports: [ReactiveFormsModule, MatDialogModule, PdvAccessFieldsComponent],
  styleUrl: "./collaborator-dialog.scss",
  template: `
    <h2 mat-dialog-title>Editar cargo e acessos</h2>
    <mat-dialog-content class="collaborator-dialog__content">
      <p>{{ data.person.email }}</p>
      <app-pdv-access-fields [controls]="form.controls" />
      @if (canApprove && data.person.pin_set) {
        <div class="form-check mb-3">
          <input
            id="resetPin"
            type="checkbox"
            class="form-check-input"
            [formControl]="form.controls.resetPin" />
          <label for="resetPin" class="form-check-label"
            >Gerar novo PIN e invalidar o anterior</label
          >
          <p>
            O PIN atual não pode ser consultado. Marque somente para
            substituí-lo.
          </p>
        </div>
      }
      @if (canApprove && !data.person.pin_set) {
        <p>Um PIN será gerado ao salvar esta autorização.</p>
      }
      @if (apiError) {
        <p role="alert" class="text-danger">{{ apiError }}</p>
      }
      <p class="collaborator-dialog__note">
        As alterações valem somente para este vínculo no evento. Outros cargos
        do usuário são preservados.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="collaborator-dialog__actions">
      <button
        class="btn btn-outline-secondary"
        [disabled]="loading"
        (click)="dialog.close()">
        Cancelar
      </button>
      <button class="btn btn-primary" [disabled]="loading" (click)="save()">
        {{ loading ? "Salvando…" : "Salvar acessos" }}
      </button>
    </mat-dialog-actions>
  `,
})
export class PdvPermissionDialogComponent {
  readonly data = inject<{
    person: Collaborator | CollaboratorInvitation;
    pending: boolean;
  }>(MAT_DIALOG_DATA);
  readonly dialog = inject(MatDialogRef<PdvPermissionDialogComponent>);
  readonly form = new FormGroup({
    ...pdvAccessControls(this.data.person),
    resetPin: new FormControl(false, { nonNullable: true }),
  });
  loading = false;
  apiError = "";
  @Output() submitted = new EventEmitter<PdvAccessSettings>();
  get canApprove() {
    return (
      this.form.controls.role.value === "pdv_portaria_coordenador" ||
      this.form.controls.role.value === "manager"
    );
  }
  save() {
    if (this.loading) return;
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    this.submitted.emit({
      ...pdvAccessPayload(this.form.controls),
      reset_pin: this.canApprove && this.form.controls.resetPin.value,
    });
  }
}
